var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":function($event){return _vm.changeResponsive()}}},[_c('feather-icon',{attrs:{"size":"21","icon":((_vm.responsive ? 'Monitor' : 'Smartphone') + "Icon")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }